import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    width: '100%',
    fontWeight: 'bold',
    height: '48px',
    fontSize: 16
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction, disabled }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      className={classes.button}
      onClick={onClickAction}
      disabled={disabled}
    >
      開店する
    </Button>
  );
});

export default withStyles(styles)(button);
